import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSolarsystem = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 500 500",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [
				/* @__PURE__ */ _jsxs("g", {
					opacity: .7,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M172.9 222.1L127.9 248.3H120L97.3003 223.4L97.6003 223.2L101.6 227.6L100.9 221.3L146.5 194.7L153.5 195.5L173.9 217.7L172.9 222.1Z",
						fill: "#001E64"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M172.9 222.1L127.9 248.3H120L97.3003 223.4L97.6003 223.2L101.6 227.6L100.9 221.3L146.5 194.7L153.5 195.5L173.9 217.7L172.9 222.1Z",
						fill: "white",
						fillOpacity: .3
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .7,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M200.8 252.8L155.8 279L147.8 278.9L129.3 258.5L128.6 252.5L174.8 225.6L181.9 226.4L201.9 248L200.8 252.8Z",
						fill: "#001E64"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M200.8 252.8L155.8 279L147.8 278.9L129.3 258.5L128.6 252.5L174.8 225.6L181.9 226.4L201.9 248L200.8 252.8Z",
						fill: "white",
						fillOpacity: .3
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .7,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M94.8002 220.2L95.3002 221.1L74.0002 197.7C72.9002 196.4 72.2002 194.7 72.2002 192.8C72.2002 190.1 73.6002 187.8 75.7002 186.5L175.6 128.2L181.1 128.8L203.2 152.9L202.1 157.7L155.5 184.9L148.5 184.2L126.8 160.7L127.8 156.3L122.8 159.2L117.8 162.1L123 162.6L145.2 186.8L144.1 191.6L99.0002 217.9L92.4002 217.8L94.8002 220.2Z",
						fill: "#001E64"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M94.8002 220.2L95.3002 221.1L74.0002 197.7C72.9002 196.4 72.2002 194.7 72.2002 192.8C72.2002 190.1 73.6002 187.8 75.7002 186.5L175.6 128.2L181.1 128.8L203.2 152.9L202.1 157.7L155.5 184.9L148.5 184.2L126.8 160.7L127.8 156.3L122.8 159.2L117.8 162.1L123 162.6L145.2 186.8L144.1 191.6L99.0002 217.9L92.4002 217.8L94.8002 220.2Z",
						fill: "white",
						fillOpacity: .3
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .7,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M210.2 257.1L230.9 279.6L230 283.8L184.5 310.1C183.4 310.8 182 311.2 180.6 311.2C178.3 311.2 176.3 310.2 174.9 308.6L157.2 289.1L156.6 283.2L202.8 256.3L210.2 257.1Z",
						fill: "#001E64"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M210.2 257.1L230.9 279.6L230 283.8L184.5 310.1C183.4 310.8 182 311.2 180.6 311.2C178.3 311.2 176.3 310.2 174.9 308.6L157.2 289.1L156.6 283.2L202.8 256.3L210.2 257.1Z",
						fill: "white",
						fillOpacity: .3
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .7,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M230.8 188.4L183.8 215.7L176.9 215L156.6 193L157.7 188.2L204.4 161L211.3 161.7L231.8 183.9L230.8 188.4Z",
						fill: "#001E64"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M230.8 188.4L183.8 215.7L176.9 215L156.6 193L157.7 188.2L204.4 161L211.3 161.7L231.8 183.9L230.8 188.4Z",
						fill: "white",
						fillOpacity: .3
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .7,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M205.2 245.7L185.2 224L186.4 218.9L232.7 191.9L239.7 192.6L259.7 214.3L258.6 219.1L211.7 246.4L205.2 245.7Z",
						fill: "#001E64"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M205.2 245.7L185.2 224L186.4 218.9L232.7 191.9L239.7 192.6L259.7 214.3L258.6 219.1L211.7 246.4L205.2 245.7Z",
						fill: "white",
						fillOpacity: .3
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .7,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M206.3 150.3L184.5 126.6L185.4 122.5L230.8 96C231.9 95.3 233.2 95 234.6 95C236.7 95 238.7 95.9 240.1 97.4L261.6 120.8L260.5 119.6L260.2 123.9L213.5 151.1L206.3 150.3Z",
						fill: "#001E64"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M206.3 150.3L184.5 126.6L185.4 122.5L230.8 96C231.9 95.3 233.2 95 234.6 95C236.7 95 238.7 95.9 240.1 97.4L261.6 120.8L260.5 119.6L260.2 123.9L213.5 151.1L206.3 150.3Z",
						fill: "white",
						fillOpacity: .3
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .7,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M215.5 154.5L262.9 126.9L268.1 127.9L288.7 150.3L288.4 154.8L241.7 182L234.7 181.2L214.5 159.2L215.5 154.5Z",
						fill: "#001E64"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M215.5 154.5L262.9 126.9L268.1 127.9L288.7 150.3L288.4 154.8L241.7 182L234.7 181.2L214.5 159.2L215.5 154.5Z",
						fill: "white",
						fillOpacity: .3
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .7,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M268 223.3L289 246.1L288 250.3L239.7 278.2L234.5 277.6L213.1 254.4L214.2 249.6L260.6 222.5L268 223.3Z",
						fill: "#001E64"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M268 223.3L289 246.1L288 250.3L239.7 278.2L234.5 277.6L213.1 254.4L214.2 249.6L260.6 222.5L268 223.3Z",
						fill: "white",
						fillOpacity: .3
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .7,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M244.2 185.2L291.4 157.6L296.3 158.6L319.4 183.6L319.3 183.7L316.9 181.1L316.6 185.3L269.6 212.7L263 212L243 190.3L244.2 185.2Z",
						fill: "#001E64"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M244.2 185.2L291.4 157.6L296.3 158.6L319.4 183.6L319.3 183.7L316.9 181.1L316.6 185.3L269.6 212.7L263 212L243 190.3L244.2 185.2Z",
						fill: "white",
						fillOpacity: .3
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .7,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M344.3 213.5C344.3 216.1 342.9 218.4 340.9 219.8L293.4 247.2L298 244.5L292.5 243.9L271 220.7L272.1 215.9L319.2 188.5L324.8 189.5L320.9 185.3L320.3 184.6L320 184.1L342.4 208.5C343.5 209.9 344.3 211.6 344.3 213.5Z",
						fill: "#001E64"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M344.3 213.5C344.3 216.1 342.9 218.4 340.9 219.8L293.4 247.2L298 244.5L292.5 243.9L271 220.7L272.1 215.9L319.2 188.5L324.8 189.5L320.9 185.3L320.3 184.6L320 184.1L342.4 208.5C343.5 209.9 344.3 211.6 344.3 213.5Z",
						fill: "white",
						fillOpacity: .3
					})]
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M178.5 331.8C175.2 331.8 172.1 330.3 169.9 327.8L60.9001 208.1C59.1001 206.1 58.1001 203.4 58.1001 200.6V191.2H61.1001V200.6C61.1001 202.7 61.8001 204.6 63.1001 206.1L172.1 325.8C173.8 327.7 176.1 328.8 178.5 328.8C180.4 328.8 182 328.1 182.9 327.5L350.3 230.4C352.7 228.8 354.1 226.3 354.1 223.4V215.1H357.1V223.4C357.1 227.2 355.2 230.8 351.9 232.9L184.4 330C182.6 331.2 180.5 331.8 178.5 331.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M178.5 331.8C175.2 331.8 172.1 330.3 169.9 327.8L60.9001 208.1C59.1001 206.1 58.1001 203.4 58.1001 200.6V191.2H61.1001V200.6C61.1001 202.7 61.8001 204.6 63.1001 206.1L172.1 325.8C173.8 327.7 176.1 328.8 178.5 328.8C180.4 328.8 182 328.1 182.9 327.5L350.3 230.4C352.7 228.8 354.1 226.3 354.1 223.4V215.1H357.1V223.4C357.1 227.2 355.2 230.8 351.9 232.9L184.4 330C182.6 331.2 180.5 331.8 178.5 331.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M178.5 322.9C175.2 322.9 172.1 321.4 169.9 318.9L60.9001 199.2C59.1001 197.2 58.1001 194.5 58.1001 191.7C58.1001 187.8 60.2001 184 63.5001 182L231 84.9C232.7 83.9 234.7 83.3 236.8 83.3C240 83.3 243 84.6 245.1 87L354.2 206.9C356 208.8 357.1 211.6 357.1 214.5C357.1 218.3 355.2 221.9 351.9 224L184.4 321.2C182.6 322.3 180.5 322.9 178.5 322.9ZM236.8 86.3C235.3 86.3 233.9 86.7 232.6 87.5L65.1001 184.6C62.7001 186.1 61.1001 188.8 61.1001 191.7C61.1001 193.8 61.8001 195.7 63.1001 197.2L172.1 316.9C173.8 318.8 176.1 319.9 178.5 319.9C180.4 319.9 182 319.2 182.9 318.6L350.3 221.5C352.7 219.9 354.1 217.4 354.1 214.5C354.1 212.4 353.3 210.3 352 208.9L242.9 89C241.3 87.2 239.2 86.3 236.8 86.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M178.5 322.9C175.2 322.9 172.1 321.4 169.9 318.9L60.9001 199.2C59.1001 197.2 58.1001 194.5 58.1001 191.7C58.1001 187.8 60.2001 184 63.5001 182L231 84.9C232.7 83.9 234.7 83.3 236.8 83.3C240 83.3 243 84.6 245.1 87L354.2 206.9C356 208.8 357.1 211.6 357.1 214.5C357.1 218.3 355.2 221.9 351.9 224L184.4 321.2C182.6 322.3 180.5 322.9 178.5 322.9ZM236.8 86.3C235.3 86.3 233.9 86.7 232.6 87.5L65.1001 184.6C62.7001 186.1 61.1001 188.8 61.1001 191.7C61.1001 193.8 61.8001 195.7 63.1001 197.2L172.1 316.9C173.8 318.8 176.1 319.9 178.5 319.9C180.4 319.9 182 319.2 182.9 318.6L350.3 221.5C352.7 219.9 354.1 217.4 354.1 214.5C354.1 212.4 353.3 210.3 352 208.9L242.9 89C241.3 87.2 239.2 86.3 236.8 86.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M180.6 312.8C178 312.8 175.5 311.7 173.8 309.7L72.9002 198.7C71.5002 197 70.7002 194.9 70.7002 192.8C70.7002 189.7 72.3002 186.9 74.9002 185.2L230 94.7C231.2 93.9 232.8 93.5 234.6 93.5C237.1 93.5 239.6 94.6 241.1 96.4L343.5 207.6C345 209.2 345.8 211.4 345.8 213.6C345.8 216.6 344.2 219.4 341.7 221.1L185.2 311.5C184 312.3 182.3 312.8 180.6 312.8ZM234.6 96.5C233.4 96.5 232.4 96.8 231.6 97.3L76.5002 187.8C74.8002 188.9 73.7002 190.7 73.7002 192.8C73.7002 194.6 74.5002 196 75.1002 196.7L176 307.7C177.2 309.1 178.8 309.8 180.6 309.8C181.7 309.8 182.8 309.5 183.7 308.9L340.2 218.5C341.8 217.5 342.9 215.6 342.9 213.6C342.9 212.1 342.4 210.7 341.4 209.6L238.9 98.4C237.8 97.2 236.3 96.5 234.6 96.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M180.6 312.8C178 312.8 175.5 311.7 173.8 309.7L72.9002 198.7C71.5002 197 70.7002 194.9 70.7002 192.8C70.7002 189.7 72.3002 186.9 74.9002 185.2L230 94.7C231.2 93.9 232.8 93.5 234.6 93.5C237.1 93.5 239.6 94.6 241.1 96.4L343.5 207.6C345 209.2 345.8 211.4 345.8 213.6C345.8 216.6 344.2 219.4 341.7 221.1L185.2 311.5C184 312.3 182.3 312.8 180.6 312.8ZM234.6 96.5C233.4 96.5 232.4 96.8 231.6 97.3L76.5002 187.8C74.8002 188.9 73.7002 190.7 73.7002 192.8C73.7002 194.6 74.5002 196 75.1002 196.7L176 307.7C177.2 309.1 178.8 309.8 180.6 309.8C181.7 309.8 182.8 309.5 183.7 308.9L340.2 218.5C341.8 217.5 342.9 215.6 342.9 213.6C342.9 212.1 342.4 210.7 341.4 209.6L238.9 98.4C237.8 97.2 236.3 96.5 234.6 96.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M319.6 183.6L319.5 183.7L320 184.2L319.6 183.6ZM288.7 150.3L296.3 158.6L296.5 158.7L292.6 154.5L288.7 150.3ZM291.5 248.9L293.3 247.3L291.1 248.6L291.5 248.9ZM288 250.3L291.1 248.5L288 250.3ZM261.5 120.7L268.1 127.8H268.3L264.4 123.6L261.5 120.7ZM230 283.8V283.9L234.9 281L239.9 278.1H239.8L230 283.8ZM181.9 123.8L180 125.5L175.5 128.2H175.6L185.4 122.5V122.4L182.3 124.2L181.9 123.8ZM147.8 278.9L152.4 284.1L157.1 289.3V289.2L147.8 278.9ZM120 248.3H119.8L124.5 253.6L125.3 254.5L129.2 258.8V258.6L120 248.3ZM96.8003 223.7L97.4003 223.4L95.3003 221.1L96.8003 223.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M319.6 183.6L319.5 183.7L320 184.2L319.6 183.6ZM288.7 150.3L296.3 158.6L296.5 158.7L292.6 154.5L288.7 150.3ZM291.5 248.9L293.3 247.3L291.1 248.6L291.5 248.9ZM288 250.3L291.1 248.5L288 250.3ZM261.5 120.7L268.1 127.8H268.3L264.4 123.6L261.5 120.7ZM230 283.8V283.9L234.9 281L239.9 278.1H239.8L230 283.8ZM181.9 123.8L180 125.5L175.5 128.2H175.6L185.4 122.5V122.4L182.3 124.2L181.9 123.8ZM147.8 278.9L152.4 284.1L157.1 289.3V289.2L147.8 278.9ZM120 248.3H119.8L124.5 253.6L125.3 254.5L129.2 258.8V258.6L120 248.3ZM96.8003 223.7L97.4003 223.4L95.3003 221.1L96.8003 223.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 436.6C353.1 436.6 352.8 436.5 352.6 436.4L286.8 400.3C286.1 399.9 285.8 399 286.2 398.3C286.6 397.6 287.5 397.3 288.2 397.7L353.3 433.4L435.5 387.3V303.6C435.5 302.8 436.2 302.1 437 302.1C437.8 302.1 438.5 302.8 438.5 303.6V388.2C438.5 388.7 438.2 389.2 437.7 389.5L354 436.4C353.8 436.5 353.6 436.6 353.3 436.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 436.6C353.1 436.6 352.8 436.5 352.6 436.4L286.8 400.3C286.1 399.9 285.8 399 286.2 398.3C286.6 397.6 287.5 397.3 288.2 397.7L353.3 433.4L435.5 387.3V303.6C435.5 302.8 436.2 302.1 437 302.1C437.8 302.1 438.5 302.8 438.5 303.6V388.2C438.5 388.7 438.2 389.2 437.7 389.5L354 436.4C353.8 436.5 353.6 436.6 353.3 436.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 361.5C352.8 361.5 352.3 361.2 352 360.7C351.6 360 351.9 359.1 352.6 358.7L436.3 311.8C437 311.4 437.9 311.7 438.3 312.4C438.7 313.1 438.4 314 437.7 314.4L354 361.3C353.8 361.4 353.6 361.5 353.3 361.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 361.5C352.8 361.5 352.3 361.2 352 360.7C351.6 360 351.9 359.1 352.6 358.7L436.3 311.8C437 311.4 437.9 311.7 438.3 312.4C438.7 313.1 438.4 314 437.7 314.4L354 361.3C353.8 361.4 353.6 361.5 353.3 361.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 416.1C352.8 416.1 352.3 415.8 352 415.3C351.6 414.6 351.9 413.7 352.6 413.3L436.3 366.4C437 366 437.9 366.3 438.3 367C438.7 367.7 438.4 368.6 437.7 369L354 415.9C353.8 416 353.6 416.1 353.3 416.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 416.1C352.8 416.1 352.3 415.8 352 415.3C351.6 414.6 351.9 413.7 352.6 413.3L436.3 366.4C437 366 437.9 366.3 438.3 367C438.7 367.7 438.4 368.6 437.7 369L354 415.9C353.8 416 353.6 416.1 353.3 416.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 399.1C352.8 399.1 352.3 398.8 352 398.3C351.6 397.6 351.9 396.7 352.6 396.3L436.3 349.4C437 349 437.9 349.3 438.3 350C438.7 350.7 438.4 351.6 437.7 352L354 398.9C353.8 399 353.6 399.1 353.3 399.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 399.1C352.8 399.1 352.3 398.8 352 398.3C351.6 397.6 351.9 396.7 352.6 396.3L436.3 349.4C437 349 437.9 349.3 438.3 350C438.7 350.7 438.4 351.6 437.7 352L354 398.9C353.8 399 353.6 399.1 353.3 399.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 382C352.8 382 352.3 381.7 352 381.2C351.6 380.5 351.9 379.6 352.6 379.2L436.3 332.3C437 331.9 437.9 332.2 438.3 332.9C438.7 333.6 438.4 334.5 437.7 334.9L354 381.8C353.8 381.9 353.6 382 353.3 382Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 382C352.8 382 352.3 381.7 352 381.2C351.6 380.5 351.9 379.6 352.6 379.2L436.3 332.3C437 331.9 437.9 332.2 438.3 332.9C438.7 333.6 438.4 334.5 437.7 334.9L354 381.8C353.8 381.9 353.6 382 353.3 382Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 361.5C353.1 361.5 352.8 361.4 352.6 361.3L286.8 325.2C286.1 324.8 285.8 323.9 286.2 323.2C286.6 322.5 287.5 322.2 288.2 322.6L354 358.7C354.7 359.1 355 360 354.6 360.7C354.3 361.2 353.8 361.5 353.3 361.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 361.5C353.1 361.5 352.8 361.4 352.6 361.3L286.8 325.2C286.1 324.8 285.8 323.9 286.2 323.2C286.6 322.5 287.5 322.2 288.2 322.6L354 358.7C354.7 359.1 355 360 354.6 360.7C354.3 361.2 353.8 361.5 353.3 361.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M333.4 392.6C333.2 392.6 332.9 392.5 332.7 392.4L306.6 378.1C305.9 377.7 305.6 376.8 306 376.1C306.4 375.4 307.3 375.1 308 375.5L334.1 389.8C334.8 390.2 335.1 391.1 334.7 391.8C334.4 392.3 333.9 392.6 333.4 392.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M333.4 392.6C333.2 392.6 332.9 392.5 332.7 392.4L306.6 378.1C305.9 377.7 305.6 376.8 306 376.1C306.4 375.4 307.3 375.1 308 375.5L334.1 389.8C334.8 390.2 335.1 391.1 334.7 391.8C334.4 392.3 333.9 392.6 333.4 392.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M333.4 401.1C333.2 401.1 332.9 401 332.7 400.9L306.6 386.6C305.9 386.2 305.6 385.3 306 384.6C306.4 383.9 307.3 383.6 308 384L334.1 398.3C334.8 398.7 335.1 399.6 334.7 400.3C334.4 400.8 333.9 401.1 333.4 401.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M333.4 401.1C333.2 401.1 332.9 401 332.7 400.9L306.6 386.6C305.9 386.2 305.6 385.3 306 384.6C306.4 383.9 307.3 383.6 308 384L334.1 398.3C334.8 398.7 335.1 399.6 334.7 400.3C334.4 400.8 333.9 401.1 333.4 401.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M333.4 409.6C333.2 409.6 332.9 409.5 332.7 409.4L306.6 395.1C305.9 394.7 305.6 393.8 306 393.1C306.4 392.4 307.3 392.1 308 392.5L334.1 406.8C334.8 407.2 335.1 408.1 334.7 408.8C334.4 409.3 333.9 409.6 333.4 409.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M333.4 409.6C333.2 409.6 332.9 409.5 332.7 409.4L306.6 395.1C305.9 394.7 305.6 393.8 306 393.1C306.4 392.4 307.3 392.1 308 392.5L334.1 406.8C334.8 407.2 335.1 408.1 334.7 408.8C334.4 409.3 333.9 409.6 333.4 409.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.6 443C353.1 443 352.6 442.7 352.3 442.2C351.9 441.5 352.2 440.6 352.9 440.2L446.6 388C447.3 387.6 448.2 387.9 448.6 388.6C449 389.3 448.7 390.2 448 390.6L354.3 442.8C354.1 442.9 353.8 443 353.6 443Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.6 443C353.1 443 352.6 442.7 352.3 442.2C351.9 441.5 352.2 440.6 352.9 440.2L446.6 388C447.3 387.6 448.2 387.9 448.6 388.6C449 389.3 448.7 390.2 448 390.6L354.3 442.8C354.1 442.9 353.8 443 353.6 443Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.6 443C353.4 443 353.1 442.9 352.9 442.8L277.1 401.2C276.4 400.8 276.1 399.9 276.5 399.2C276.9 398.5 277.8 398.2 278.5 398.6L354.3 440.2C355 440.6 355.3 441.5 354.9 442.2C354.6 442.7 354.1 443 353.6 443Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.6 443C353.4 443 353.1 442.9 352.9 442.8L277.1 401.2C276.4 400.8 276.1 399.9 276.5 399.2C276.9 398.5 277.8 398.2 278.5 398.6L354.3 440.2C355 440.6 355.3 441.5 354.9 442.2C354.6 442.7 354.1 443 353.6 443Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.6 454.8C353.1 454.8 352.6 454.5 352.3 454C351.9 453.3 352.2 452.4 352.9 452L445.8 400.2V389.3C445.8 388.5 446.5 387.8 447.3 387.8C448.1 387.8 448.8 388.5 448.8 389.3V401.1C448.8 401.6 448.5 402.1 448 402.4L354.3 454.6C354.1 454.7 353.8 454.8 353.6 454.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.6 454.8C353.1 454.8 352.6 454.5 352.3 454C351.9 453.3 352.2 452.4 352.9 452L445.8 400.2V389.3C445.8 388.5 446.5 387.8 447.3 387.8C448.1 387.8 448.8 388.5 448.8 389.3V401.1C448.8 401.6 448.5 402.1 448 402.4L354.3 454.6C354.1 454.7 353.8 454.8 353.6 454.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.6 454.8C353.4 454.8 353.1 454.7 352.9 454.6L277.1 413C276.6 412.7 276.3 412.2 276.3 411.7V399.9C276.3 399.1 277 398.4 277.8 398.4C278.6 398.4 279.3 399.1 279.3 399.9V410.8L354.3 452C355 452.4 355.3 453.3 354.9 454C354.6 454.5 354.1 454.8 353.6 454.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.6 454.8C353.4 454.8 353.1 454.7 352.9 454.6L277.1 413C276.6 412.7 276.3 412.2 276.3 411.7V399.9C276.3 399.1 277 398.4 277.8 398.4C278.6 398.4 279.3 399.1 279.3 399.9V410.8L354.3 452C355 452.4 355.3 453.3 354.9 454C354.6 454.5 354.1 454.8 353.6 454.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M447.3 390.8C447.1 390.8 446.8 390.7 446.6 390.6L436.3 385C435.6 384.6 435.3 383.7 435.7 383C436.1 382.3 437 382 437.7 382.4L448 388C448.7 388.4 449 389.3 448.6 390C448.3 390.5 447.8 390.8 447.3 390.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M447.3 390.8C447.1 390.8 446.8 390.7 446.6 390.6L436.3 385C435.6 384.6 435.3 383.7 435.7 383C436.1 382.3 437 382 437.7 382.4L448 388C448.7 388.4 449 389.3 448.6 390C448.3 390.5 447.8 390.8 447.3 390.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M277.8 401.3C277.3 401.3 276.7 401 276.5 400.5C276.1 399.8 276.4 398.9 277.1 398.5L286.8 393.3C287.5 392.9 288.4 393.2 288.8 393.9C289.2 394.6 288.9 395.5 288.2 395.9L278.5 401.1C278.3 401.2 278 401.3 277.8 401.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M277.8 401.3C277.3 401.3 276.7 401 276.5 400.5C276.1 399.8 276.4 398.9 277.1 398.5L286.8 393.3C287.5 392.9 288.4 393.2 288.8 393.9C289.2 394.6 288.9 395.5 288.2 395.9L278.5 401.1C278.3 401.2 278 401.3 277.8 401.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 351.7C353.1 351.7 352.8 351.6 352.6 351.5L286.8 315.4C286.3 315.1 286 314.6 286 314.1C286 313.6 286.3 313.1 286.8 312.8L370.3 265.8C370.8 265.5 371.3 265.5 371.8 265.8L437.8 302C438.3 302.3 438.6 302.8 438.6 303.3C438.6 303.8 438.3 304.3 437.8 304.6L354 351.5C353.8 351.6 353.6 351.7 353.3 351.7ZM290.6 314.1L353.3 348.5L433.9 303.3L371 268.8L290.6 314.1Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.3 351.7C353.1 351.7 352.8 351.6 352.6 351.5L286.8 315.4C286.3 315.1 286 314.6 286 314.1C286 313.6 286.3 313.1 286.8 312.8L370.3 265.8C370.8 265.5 371.3 265.5 371.8 265.8L437.8 302C438.3 302.3 438.6 302.8 438.6 303.3C438.6 303.8 438.3 304.3 437.8 304.6L354 351.5C353.8 351.6 353.6 351.7 353.3 351.7ZM290.6 314.1L353.3 348.5L433.9 303.3L371 268.8L290.6 314.1Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M371 267.1L287.5 314.1L353.3 350.2L437 303.3L371 267.1ZM336.1 318L317.6 307.9L362.2 282.6L380.7 292.8L336.1 318Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M371 267.1L287.5 314.1L353.3 350.2L437 303.3L371 267.1ZM336.1 318L317.6 307.9L362.2 282.6L380.7 292.8L336.1 318Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M335.4 320.4C335.2 320.4 334.9 320.3 334.7 320.2L315.3 309.6C314.8 309.3 314.5 308.8 314.5 308.3C314.5 307.8 314.8 307.3 315.3 307L362.1 280.3C362.6 280 363.1 280 363.6 280.3L383 291C383.5 291.3 383.8 291.8 383.8 292.3C383.8 292.8 383.5 293.3 383 293.6L336.1 320.2C335.9 320.3 335.7 320.4 335.4 320.4ZM319.1 308.3L335.4 317.2L379.2 292.3L362.8 283.3L319.1 308.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M335.4 320.4C335.2 320.4 334.9 320.3 334.7 320.2L315.3 309.6C314.8 309.3 314.5 308.8 314.5 308.3C314.5 307.8 314.8 307.3 315.3 307L362.1 280.3C362.6 280 363.1 280 363.6 280.3L383 291C383.5 291.3 383.8 291.8 383.8 292.3C383.8 292.8 383.5 293.3 383 293.6L336.1 320.2C335.9 320.3 335.7 320.4 335.4 320.4ZM319.1 308.3L335.4 317.2L379.2 292.3L362.8 283.3L319.1 308.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M362.2 282.6L317.6 307.9L336.1 318L380.8 292.7L362.2 282.6ZM336.7 314.8L323.7 307.7L335.4 301L342.9 311.2L336.7 314.8ZM344.4 310.4L336.9 300.2L345.2 295.5L352.7 305.7L344.4 310.4ZM346.7 294.6L355 289.9L362.5 300.1L354.2 304.8L346.7 294.6Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M362.2 282.6L317.6 307.9L336.1 318L380.8 292.7L362.2 282.6ZM336.7 314.8L323.7 307.7L335.4 301L342.9 311.2L336.7 314.8ZM344.4 310.4L336.9 300.2L345.2 295.5L352.7 305.7L344.4 310.4ZM346.7 294.6L355 289.9L362.5 300.1L354.2 304.8L346.7 294.6Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M287.5 400.3C286.7 400.3 286 399.6 286 398.8V314.2C286 313.4 286.7 312.7 287.5 312.7C288.3 312.7 289 313.4 289 314.2V398.8C289 399.6 288.3 400.3 287.5 400.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M287.5 400.3C286.7 400.3 286 399.6 286 398.8V314.2C286 313.4 286.7 312.7 287.5 312.7C288.3 312.7 289 313.4 289 314.2V398.8C289 399.6 288.3 400.3 287.5 400.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.4 436.2C352.6 436.2 351.9 435.5 351.9 434.7V350.2C351.9 349.4 352.6 348.7 353.4 348.7C354.2 348.7 354.9 349.4 354.9 350.2V434.7C354.9 435.5 354.2 436.2 353.4 436.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M353.4 436.2C352.6 436.2 351.9 435.5 351.9 434.7V350.2C351.9 349.4 352.6 348.7 353.4 348.7C354.2 348.7 354.9 349.4 354.9 350.2V434.7C354.9 435.5 354.2 436.2 353.4 436.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.2998 295.2C74.7998 295.2 74.2998 294.9 73.9998 294.4C73.5998 293.7 73.7998 292.8 74.5998 292.4L80.6998 288.9V229.2C80.6998 228.4 81.3998 227.7 82.1998 227.7C82.9998 227.7 83.6998 228.4 83.6998 229.2V289.8C83.6998 290.3 83.3998 290.8 82.8998 291.1L75.9998 295C75.7998 295.1 75.5998 295.2 75.2998 295.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.2998 295.2C74.7998 295.2 74.2998 294.9 73.9998 294.4C73.5998 293.7 73.7998 292.8 74.5998 292.4L80.6998 288.9V229.2C80.6998 228.4 81.3998 227.7 82.1998 227.7C82.9998 227.7 83.6998 228.4 83.6998 229.2V289.8C83.6998 290.3 83.3998 290.8 82.8998 291.1L75.9998 295C75.7998 295.1 75.5998 295.2 75.2998 295.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.8999 301.7C68.0999 301.7 67.3999 301 67.3999 300.2V214.7C67.3999 213.9 68.0999 213.2 68.8999 213.2C69.6999 213.2 70.3999 213.9 70.3999 214.7V300.2C70.3999 301 69.6999 301.7 68.8999 301.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.8999 301.7C68.0999 301.7 67.3999 301 67.3999 300.2V214.7C67.3999 213.9 68.0999 213.2 68.8999 213.2C69.6999 213.2 70.3999 213.9 70.3999 214.7V300.2C70.3999 301 69.6999 301.7 68.8999 301.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M158.3 350.8C157.5 350.8 156.8 350.1 156.8 349.3V313.3C156.8 312.5 157.5 311.8 158.3 311.8C159.1 311.8 159.8 312.5 159.8 313.3V349.3C159.8 350.1 159.1 350.8 158.3 350.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M158.3 350.8C157.5 350.8 156.8 350.1 156.8 349.3V313.3C156.8 312.5 157.5 311.8 158.3 311.8C159.1 311.8 159.8 312.5 159.8 313.3V349.3C159.8 350.1 159.1 350.8 158.3 350.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.2998 295.2C74.4998 295.2 73.7998 294.5 73.7998 293.7V221.6C73.7998 220.8 74.4998 220.1 75.2998 220.1C76.0998 220.1 76.7998 220.8 76.7998 221.6V293.7C76.7998 294.5 76.0998 295.2 75.2998 295.2Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.2998 295.2C74.4998 295.2 73.7998 294.5 73.7998 293.7V221.6C73.7998 220.8 74.4998 220.1 75.2998 220.1C76.0998 220.1 76.7998 220.8 76.7998 221.6V293.7C76.7998 294.5 76.0998 295.2 75.2998 295.2Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M158.3 350.8C157.8 350.8 157.3 350.5 157 350C156.6 349.3 156.9 348.4 157.6 348L163.7 344.6V320.6C163.7 319.8 164.4 319.1 165.2 319.1C166 319.1 166.7 319.8 166.7 320.6V345.5C166.7 346 166.4 346.5 165.9 346.8L159 350.6C158.8 350.7 158.5 350.8 158.3 350.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M158.3 350.8C157.8 350.8 157.3 350.5 157 350C156.6 349.3 156.9 348.4 157.6 348L163.7 344.6V320.6C163.7 319.8 164.4 319.1 165.2 319.1C166 319.1 166.7 319.8 166.7 320.6V345.5C166.7 346 166.4 346.5 165.9 346.8L159 350.6C158.8 350.7 158.5 350.8 158.3 350.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152 337.3C151.2 337.3 150.5 336.6 150.5 335.8V306.5C150.5 305.7 151.2 305 152 305C152.8 305 153.5 305.7 153.5 306.5V335.8C153.5 336.6 152.8 337.3 152 337.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152 337.3C151.2 337.3 150.5 336.6 150.5 335.8V306.5C150.5 305.7 151.2 305 152 305C152.8 305 153.5 305.7 153.5 306.5V335.8C153.5 336.6 152.8 337.3 152 337.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M158.3 350.8C158.1 350.8 157.8 350.7 157.6 350.6L68.2001 301.5C67.5001 301.1 67.2001 300.2 67.6001 299.5C68.0001 298.8 68.9001 298.5 69.6001 298.9L159 348C159.7 348.4 160 349.3 159.6 350C159.3 350.5 158.8 350.8 158.3 350.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M158.3 350.8C158.1 350.8 157.8 350.7 157.6 350.6L68.2001 301.5C67.5001 301.1 67.2001 300.2 67.6001 299.5C68.0001 298.8 68.9001 298.5 69.6001 298.9L159 348C159.7 348.4 160 349.3 159.6 350C159.3 350.5 158.8 350.8 158.3 350.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152 337.3C151.8 337.3 151.5 337.2 151.3 337.1L74.6 295C73.9 294.6 73.6 293.7 74 293C74.4 292.3 75.3 292 76 292.4L152.7 334.5C153.4 334.9 153.7 335.8 153.3 336.5C153 337 152.5 337.3 152 337.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152 337.3C151.8 337.3 151.5 337.2 151.3 337.1L74.6 295C73.9 294.6 73.6 293.7 74 293C74.4 292.3 75.3 292 76 292.4L152.7 334.5C153.4 334.9 153.7 335.8 153.3 336.5C153 337 152.5 337.3 152 337.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152 329.6C151.8 329.6 151.5 329.5 151.3 329.4L81.4999 291.1C80.7999 290.7 80.4999 289.8 80.8999 289.1C81.2999 288.4 82.1999 288.1 82.8999 288.5L152.7 326.8C153.4 327.2 153.7 328.1 153.3 328.8C153 329.3 152.5 329.6 152 329.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152 329.6C151.8 329.6 151.5 329.5 151.3 329.4L81.4999 291.1C80.7999 290.7 80.4999 289.8 80.8999 289.1C81.2999 288.4 82.1999 288.1 82.8999 288.5L152.7 326.8C153.4 327.2 153.7 328.1 153.3 328.8C153 329.3 152.5 329.6 152 329.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.1 255.3C328.3 255.3 327.6 254.6 327.6 253.8V244.6C327.6 243.8 328.3 243.1 329.1 243.1C329.9 243.1 330.6 243.8 330.6 244.6V253.8C330.6 254.6 329.9 255.3 329.1 255.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.1 255.3C328.3 255.3 327.6 254.6 327.6 253.8V244.6C327.6 243.8 328.3 243.1 329.1 243.1C329.9 243.1 330.6 243.8 330.6 244.6V253.8C330.6 254.6 329.9 255.3 329.1 255.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.1 255.3C328.6 255.3 328.1 255 327.8 254.5C327.4 253.8 327.6 252.9 328.4 252.5L334.5 249V240.6C334.5 239.8 335.2 239.1 336 239.1C336.8 239.1 337.5 239.8 337.5 240.6V249.9C337.5 250.4 337.2 250.9 336.7 251.2L329.8 255.1C329.6 255.2 329.4 255.3 329.1 255.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.1 255.3C328.6 255.3 328.1 255 327.8 254.5C327.4 253.8 327.6 252.9 328.4 252.5L334.5 249V240.6C334.5 239.8 335.2 239.1 336 239.1C336.8 239.1 337.5 239.8 337.5 240.6V249.9C337.5 250.4 337.2 250.9 336.7 251.2L329.8 255.1C329.6 255.2 329.4 255.3 329.1 255.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.1 255.3C328.8 255.3 328.6 255.2 328.4 255.1L320.3 250.5C319.6 250.1 319.3 249.2 319.7 248.5C320.1 247.8 321 247.5 321.7 247.9L329.8 252.5C330.5 252.9 330.8 253.8 330.4 254.5C330.1 255 329.6 255.3 329.1 255.3Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.1 255.3C328.8 255.3 328.6 255.2 328.4 255.1L320.3 250.5C319.6 250.1 319.3 249.2 319.7 248.5C320.1 247.8 321 247.5 321.7 247.9L329.8 252.5C330.5 252.9 330.8 253.8 330.4 254.5C330.1 255 329.6 255.3 329.1 255.3Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M427.5 351.8L424.7 353.3V344.4L427.5 342.9V351.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M427.5 351.8L424.7 353.3V344.4L427.5 342.9V351.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M430 347.5L422.4 351.6V348.5L430 344.5V347.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M430 347.5L422.4 351.6V348.5L430 344.5V347.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M427.5 332.9L424.7 334.3V325.4L427.5 323.9V332.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M427.5 332.9L424.7 334.3V325.4L427.5 323.9V332.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M430 328.6L422.4 332.7V329.6L430 325.6V328.6Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M430 328.6L422.4 332.7V329.6L430 325.6V328.6Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M427.5 368.7L424.7 370.2V361.3L427.5 359.8V368.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M427.5 368.7L424.7 370.2V361.3L427.5 359.8V368.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M430 364.5L422.4 368.5V365.5L430 361.4V364.5Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M430 364.5L422.4 368.5V365.5L430 361.4V364.5Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M417.6 353.8L410 357.8V354.8L417.6 350.7V353.8Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M417.6 353.8L410 357.8V354.8L417.6 350.7V353.8Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M417.6 334.9L410 338.9V335.9L417.6 331.8V334.9Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M417.6 334.9L410 338.9V335.9L417.6 331.8V334.9Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M417.6 370.7L410 374.8V371.7L417.6 367.6V370.7Z",
			fill: "#001E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M417.6 370.7L410 374.8V371.7L417.6 367.6V370.7Z",
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M353.8 453.7L278.9 412.9V400.4L353.8 441.2V453.7Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M353.8 453.7L278.9 412.9V400.4L353.8 441.2V453.7Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M352.7 434.5L287.5 398.7V324.9L352.7 360.7V434.5Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M352.7 434.5L287.5 398.7V324.9L352.7 360.7V434.5Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M352.7 359.1L287.5 323.2V314.6L352.7 350.4V359.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M352.7 359.1L287.5 323.2V314.6L352.7 350.4V359.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M353.6 359.1L437 313.4V304.7L353.6 350.4V359.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M353.6 359.1L437 313.4V304.7L353.6 350.4V359.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M353.9 454.2L447.2 402.5V390L353.9 441.7V454.2Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M353.9 454.2L447.2 402.5V390L353.9 441.7V454.2Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M158.4 313.7L152.8 307.5V336.1L74.4999 293.1V222.1L68.8999 216V300.5L158.3 349.5V345.7L158.4 345.8V313.7Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M158.4 313.7L152.8 307.5V336.1L74.4999 293.1V222.1L68.8999 216V300.5L158.3 349.5V345.7L158.4 345.8V313.7Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M158.3 350.1L165.2 346.5V320.5L158.3 313.3V350.1Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M158.3 350.1L165.2 346.5V320.5L158.3 313.3V350.1Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M75.2998 294.2L82.0998 290.6V230.2L75.2998 222.9V294.2Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M75.2998 294.2L82.0998 290.6V230.2L75.2998 222.9V294.2Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M152 335.8L152.1 328.6L82.1998 289.7L76.2998 293.7L152 335.8Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M152 335.8L152.1 328.6L82.1998 289.7L76.2998 293.7L152 335.8Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M353.8 414.4L437 368.4V313.6L353.8 359.6V414.4Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M353.8 414.4L437 368.4V313.6L353.8 359.6V414.4Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M353.8 434.5L437 388.5V367.6L353.8 413.7V434.5Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M353.8 434.5L437 388.5V367.6L353.8 413.7V434.5Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M59.6001 198L61.3001 197.2L171 317.9L176.4 321.1L182.6 320.5L352.7 221.5L355.6 221.4L352.7 231.3L198.1 320.5L180.4 330.3L173.4 328.9L169.1 324.7L60.4001 204.5L59.6001 198Z",
				fill: "#001E64"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M59.6001 198L61.3001 197.2L171 317.9L176.4 321.1L182.6 320.5L352.7 221.5L355.6 221.4L352.7 231.3L198.1 320.5L180.4 330.3L173.4 328.9L169.1 324.7L60.4001 204.5L59.6001 198Z",
				fill: "white",
				fillOpacity: .3
			})]
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .2,
			children: /* @__PURE__ */ _jsxs("g", {
				opacity: .2,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M353.1 207.9L244 88C242.2 86.1 239.6 84.9 236.8 84.9C235 84.9 233.3 85.4 231.8 86.3L64.3001 183.4C61.5001 185.1 59.6001 188.3 59.6001 191.8C59.6001 194.3 60.5001 196.6 62.0001 198.3L171 318C172.8 320.1 175.5 321.5 178.5 321.5C180.4 321.5 182.2 321 183.7 320L351.1 222.9C353.8 221.1 355.6 218.1 355.6 214.6C355.6 211.9 354.7 209.6 353.1 207.9ZM340.8 219.8L184.4 310.2C183.3 310.9 181.9 311.3 180.5 311.3C178.2 311.3 176.2 310.3 174.8 308.7L74.0001 197.7C72.9001 196.4 72.2001 194.7 72.2001 192.8C72.2001 190.1 73.6001 187.8 75.7001 186.5L230.7 96C231.8 95.3 233.1 95 234.5 95C236.6 95 238.6 95.9 240 97.4L342.4 208.6C343.6 209.9 344.3 211.7 344.3 213.6C344.3 216.1 342.9 218.4 340.8 219.8Z",
					fill: "#001E64"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M353.1 207.9L244 88C242.2 86.1 239.6 84.9 236.8 84.9C235 84.9 233.3 85.4 231.8 86.3L64.3001 183.4C61.5001 185.1 59.6001 188.3 59.6001 191.8C59.6001 194.3 60.5001 196.6 62.0001 198.3L171 318C172.8 320.1 175.5 321.5 178.5 321.5C180.4 321.5 182.2 321 183.7 320L351.1 222.9C353.8 221.1 355.6 218.1 355.6 214.6C355.6 211.9 354.7 209.6 353.1 207.9ZM340.8 219.8L184.4 310.2C183.3 310.9 181.9 311.3 180.5 311.3C178.2 311.3 176.2 310.3 174.8 308.7L74.0001 197.7C72.9001 196.4 72.2001 194.7 72.2001 192.8C72.2001 190.1 73.6001 187.8 75.7001 186.5L230.7 96C231.8 95.3 233.1 95 234.5 95C236.6 95 238.6 95.9 240 97.4L342.4 208.6C343.6 209.9 344.3 211.7 344.3 213.6C344.3 216.1 342.9 218.4 340.8 219.8Z",
					fill: "white",
					fillOpacity: .3
				})]
			})
		})
	]
});
export default SvgSolarsystem;
